import PortalToTarget from 'v3/common/components/PortalToTarget';

const oneIndentation = ' ';

const Sharekhan = () => (
  <div id="stepper__container">
    <PortalToTarget targetClassName="login-modal__header" allowForWeb>
      <h3>Sharekhan API Setup in 6 Steps</h3>
    </PortalToTarget>
    <div className="stepper">
      <li className="stepper_item" data-stepper="1">
        <div className="stepper_content">
          <h3 className="stepper__heading">Step 1</h3>
          <p>
            Sign in to your Sharekhan account by clicking on this link:
            {oneIndentation}
            <b>
              <a href="https://newtrade.sharekhan.com/" target="blank" title="Sharekhan Login step 1">
                https://newtrade.sharekhan.com/.
              </a>
            </b>
          </p>
        </div>
      </li>

      <li className="stepper_item" data-stepper="2">
        <div className="stepper_content">
          <h3 className="stepper__heading">Step 2</h3>
          <p>Select the menu icon in the upper right corner.</p>
          <img
            src="/images/broker_setup_guide/sharekhan/sharekhan_step_2.png"
            className="w-100"
            alt="Sharekhan Step 2"
          />
        </div>
      </li>

      <li className="stepper_item" data-stepper="3">
        <div className="stepper_content">
          <h3 className="stepper__heading">Step 3</h3>
          <p>
            Select
            {oneIndentation}
            <b>Trading API</b>
            {oneIndentation}
            from the
            {oneIndentation}
            <b>Sharekhan products</b>
            {oneIndentation}
            <b>menu</b>
          </p>

          <img
            src="/images/broker_setup_guide/sharekhan/sharekhan_step_3.png"
            className="w-100"
            alt="Sharekhan Step 3"
          />
        </div>
      </li>

      <li className="stepper_item" data-stepper="4">
        <div className="stepper_content">
          <h3 className="stepper__heading">Step 4</h3>
          <p>
            Click
            {oneIndentation}
            <b>Create New App,</b>
            {oneIndentation}
            then select
            {oneIndentation}
            <b>Partners App,</b>
            {oneIndentation}
            fill out the form with following details, and click Create.
          </p>

          <div>
            <p>
              <b>App Name:</b>
              {oneIndentation}
              Quantman
            </p>
          </div>
        </div>
      </li>

      <li className="stepper_item" data-stepper="5">
        <div className="stepper_content">
          <h3 className="stepper__heading">Step 5</h3>
          <p>You can now copy and paste the API details into the appropriate fields below.</p>
          <img
            src="/images/broker_setup_guide/sharekhan/sharekhan_step_5.png"
            className="w-100"
            alt="Sharekhan Step 5"
          />
        </div>
      </li>
      <li className="stepper_item" data-stepper="6">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Click the back button and fill the API credentials in the required field
          </h2>
          <img src="/landing-page-img/brokers-img/last-step.png" alt="Sharekhan fill form" />
        </div>
      </li>
    </div>
  </div>
);

export default Sharekhan;
